var EditOrganizationModal;

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import Modal from 'trunks/vue/admin/components/modals/modal.js';

export default EditOrganizationModal = Vue.extend({
  props: {
    node: {
      type: Object
    },
    successCallback: {
      type: Function
    }
  },
  components: {
    modal: Modal
  },
  template: `<modal title="修改组织名称"
       extendClass="organization-name-modal"
       @ensureClicked="ensureClicked"
       size='small'
       ref="organizationNameModalRef">
  <template>
    <div class="modal-body">
      <div>
        <div class="title mb-2">组织名称:</div>
        <input type="text"
               placeholder="请输入组织名称"
               v-model.trim="organizationName" />
      </div>
    </div>
  </template>
</modal>`,
  data: function() {
    return {
      organizationName: this.node.name
    };
  },
  methods: {
    ensureClicked: function(modal) {
      if (this.organizationName) {
        return Skylark.Libs.Ajax.patch(`/admin/organizations/${this.node.id}`, {
          contentType: 'application/json; charset=utf-8',
          responseType: 'json',
          data: {
            organization: {
              name: this.organizationName
            }
          },
          success: () => {
            newAlertify('组织名称修改成功', {
              type: 'success'
            });
            modal.close();
            return this.successCallback(this);
          }
        });
      } else {
        newAlertify('组织名称不能为空', {
          type: 'error'
        });
        return modal.open();
      }
    }
  }
});
